




























import { tCashbackParams } from '@/store/interfaces/cashback';
import { DiscountParams } from '@/store/interfaces/discount';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'DiscountRecurrence',
  props: {
    model: {
      type: Object as PropType<DiscountParams | tCashbackParams>,
      required: true,
    },
  },
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(value: DiscountParams | tCashbackParams) {
        this.$emit('update:model', value);
      },
    },
  },
});
